export default __webpack_public_path__ + "static/media/KOD0105-min.9a7dcb7a.webp";